import React, { useState, useEffect, useRef } from "react";
import "./styles.scss";
import Card from "./Card";
import KioskApp from "../../KioskApp";
import { useSelector } from "react-redux";

interface CardData {
  title: string;
  url: string;
}
 
const CardList: React.FC = () => {
  const popupRef =  useRef<Window[]>([]);
  const isLoggedIn = useSelector((state:any) => state.auth.isLoggedIn);
  console.log(isLoggedIn)
 

  // const cards: CardData[] = [
  //   {
  //     title: "Buy a Membership",
  //     url: "https://alpha.perfectmind.com/12376857/Client/MembershipWidget/List?widgetId=01e054d0-8860-49bb-8186-ff6d0a610b71",
  //   },
  //   {
  //     title: "Aquatics Admissions",
  //     url: "https://alpha.perfectmind.com/12376857/Clients/ProductWidget/Get?widgetId=790456eb-ae34-4276-a6aa-9d88a7ffe2e7",
  //   },
  //   {
  //     title: "Fitness Admissions",
  //     url: "https://alpha.perfectmind.com/12376857/Store/Product?sortField=&sortAsc=False&criteria=&viewId=5d9825b7-fb49-4c6a-9c15-02b427a66d72",
  //   },
  // ];

  const handleCardClick = (url: string) => {
    if (isLoggedIn) {
      const popup = window.open(url, "_blank", "width=1024,height=768");
      if (popup) {
        popupRef.current.push(popup); // Store the reference to the popup
      }
    }
    else{
      window.open(url, "_blank", "width=1024,height=768");
    }
  };
 
  useEffect(() => {
    if (!isLoggedIn) {
      popupRef.current.forEach((popup) => {
        popup.close();
      });
      popupRef.current = [];
    }
  }, [isLoggedIn]);
  const cursorStyle = isLoggedIn ? "pointer" : "default";
 
  return (
    <div className="App">
      {/* <div className="product-grid">
        {cards.map((card, index) => (
          <Card
            key={index}
            title={card.title}
            url={card.url}
            onClick={() => handleCardClick(card.url)}
            style={{
              cursor: "pointer" ,
            }}
          />
        ))}
      </div> */}
      <div className="kiosk-container">
        <KioskApp />
      </div>
    </div>
  );
};
 
export default CardList;